// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "./turbo_stream_custom_actions";
import { application } from "./controllers";
import "trix";
import "@rails/actiontext";
import TurboPower from "turbo_power";
import { HSStaticMethods, HSTabs, HSCarousel } from "preline/dist/preline.js";

window.Stimulus = { application };
TurboPower.initialize(Turbo.StreamActions);

document.addEventListener("turbo:load", (event) => {
  try {
    HSStaticMethods.autoInit();
  } catch (error) {
    console.error("Erreur lors de l'initialisation de Preline:", error);
  }

  try {
    const urlParams = new URLSearchParams(window.location.search);
    const tabValue = urlParams.get("tab");
    if (tabValue) {
      const tabParam = `horizontal-scroll-tab-${tabValue}`;
      HSTabs.open(`button[data-hs-tab="#${tabParam}"]`);
    }
  } catch (error) {
    console.error("Erreur lors de l'ouverture de l'onglet:", error);
  }
});

document.addEventListener("click", (e) => {
  const tabBtn = e.target.closest("[data-hs-tab]");
  if (!tabBtn) return;
  const targetSelector = tabBtn.getAttribute("data-hs-tab");
  if (!targetSelector) return;
  setTimeout(() => {
    const targetPanel = document.querySelector(targetSelector);
    if (!targetPanel) return;
    targetPanel.querySelectorAll("[data-hs-carousel]").forEach((carouselEl) => {
      const existing = HSCarousel.getInstance(carouselEl);
      if (existing) existing.destroy();
      new HSCarousel(carouselEl);
    });
  }, 0);
});

addEventListener("turbo:before-stream-render", (event) => {
  const render = event.detail.render;
  event.detail.render = (streamElement) => {
    render(streamElement);
    setTimeout(() => {
      try {
        HSStaticMethods.autoInit();
      } catch (error) {
        console.error("Erreur lors de la réinitialisation de Preline:", error);
      }
    }, 50);
  };
});
